import Layout from "../Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../Layout/loader";

import { FaPlus } from "react-icons/fa6";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { IoSearchSharp } from "react-icons/io5";

import ModalCardapios from "./modal";
import { codigoEvento } from "../Utils/utils";

function Cardapios() {
  useEffect(() => {
    refreshCardapios();
  }, []);

  async function refreshCardapiosModal(codigoCardapio) {
    const retorno = await axios.get(
      `${process.env.REACT_APP_API_URL}/Cardapio`,
      {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      }
    );

    if (retorno.status === 200) {
      refreshCardapios();
      return {
        status: true,
        data: retorno.data.filter(
          (cardapio) => cardapio.CODIGO === codigoCardapio
        ),
      };
    } else {
      return { status: false, data: {} };
    }
  }

  function refreshCardapios() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Cardapio`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setCardapios(res.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/Produto`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((produtos) => {
        if (produtos.status === 200) {
          setProdutos(produtos.data);
        } else {
          setIsLoading(false);
        }
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/Grupo`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((grupos) => {
        if (grupos.status === 200) {
          let semGrupo = {
            CODIGO: 0,
            DESCRICAO: "Sem Grupo",
            IMAGEM: "01.png",
            COR: "$00B48246",
          };
          setGrupos([semGrupo, ...grupos.data]);
        } else {
          setIsLoading(false);
        }
      });
  }

  const [isLoading, setIsLoading] = useState(true);
  const [cardapios, setCardapios] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalData, setModalData] = useState({});
  const [produtos, setProdutos] = useState([]);
  const [grupos, setGrupos] = useState([]);

  const filtrados = cardapios.filter((cardapio) => {
    return (
      cardapio.DESCRICAO.toLowerCase().includes(filtro.toLowerCase()) ||
      cardapio.CODIGO.toString().includes(filtro)
    );
  });

  function handleCloseModal() {
    setOpenModal(false);
    setModalType("");
    setModalData({});
  }

  function handleNewMenu(data) {
    axios
      .post(`${process.env.REACT_APP_API_URL}/Cardapio`, data, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        refreshCardapios();
      });
  }

  function handleEditMenu(data) {
    //console.log(data);

    axios
      .put(`${process.env.REACT_APP_API_URL}/Cardapio`, data, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
      })
      .then((retorno) => {
        refreshCardapios();
      });
  }

  function handleDeleteMenu(data) {
    axios
      .delete(`${process.env.REACT_APP_API_URL}/Cardapio`, {
        headers: {
          auth: process.env.REACT_APP_API_TOKEN,
          "Content-Type": "application/json",
        },
        params: {
          codaluguel: codigoEvento(),
          codigoCardapio: data.codigo,
        },
      })
      .then((retorno) => {
        refreshCardapios();
      });
  }

  return (
    <Layout>
      <div className="font-Roboto flex box-border p-2 lg:p-12 flex-col gap-4 justify-center items-center w-full">
        {openModal ? (
          <ModalCardapios
            type={modalType}
            cardapio={modalData}
            produtos={produtos}
            grupos={grupos}
            onClose={handleCloseModal}
            onNew={handleNewMenu}
            onEdit={handleEditMenu}
            onDelete={handleDeleteMenu}
            onRefresh={refreshCardapiosModal}
          />
        ) : null}

        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="flex flex-col gap-2 w-full lg:w-[80%] justify-center items-center">
              <h1 className="font-Oswald">Cardápios</h1>
            </div>

            <div className="flex gap-4 flex-wrap w-full justify-between lg:w-[80%]">
              <div className="flex gap-2 items-center">
                <button
                  onClick={() => {
                    setOpenModal(true);
                    setModalType("create");
                  }}
                  className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                >
                  <FaPlus />

                  <span>Cardápio</span>
                </button>
              </div>

              <input
                type="text"
                placeholder="Pesquisar Cardápio..."
                className="p-2 text-base rounded-lg border border-solid border-gray-200"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
            </div>

            <div className="flex flex-col h-auto gap-2 box-border overflow-visible rounded-lg w-full lg:w-[80%]">
              {filtrados.map((cardapio, i) => (
                <div
                  key={cardapio.DESCRICAO + i}
                  className="flex justify-between p-2 lg:p-4 border rounded-lg border-solid border-gray-200"
                >
                  <div className="flex gap-2 items-center">
                    <span>
                      {cardapio.CODIGO} - {cardapio.DESCRICAO}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2 justify-end">
                    {/* TO DO: ADICIONAR TOOLTIPS AOS BOTÕES */}
                    <button
                      onClick={() => {
                        setOpenModal(true);
                        setModalType("edit");
                        setModalData(cardapio);
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                    >
                      <FaPencilAlt />
                    </button>
                    <button
                      onClick={() => {
                        setOpenModal(true);
                        setModalType("view");
                        setModalData(cardapio);
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#9b59b6] text-white transition cursor-pointer hover:bg-[#8e44ad] font-Roboto"
                    >
                      <IoSearchSharp />
                    </button>
                    <button
                      onClick={() => {
                        setOpenModal(true);
                        setModalType("delete");
                        setModalData(cardapio);
                      }}
                      className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#e74c3c] text-white transition cursor-pointer hover:bg-[#c0392b] font-Roboto"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
export default Cardapios;
